import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import { ITINERARY_SUPPLIER_FOOD_ENDPOINT } from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  EXCEL_GET_CONFIG,
} from '../../config/rest';
import {
  CLEAR_ITINERARY_SUPPLIER_FOOD,
  CLEAR_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE,
  CLEAR_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT,
  CLEAR_ITINERARY_SUPPLIER_FOOD_REPORT,
  CLEAR_ITINERARY_SUPPLIER_FOOD_REPORT_DETAIL,
  CLEAR_ITINERARY_SUPPLIER_FOODS,
  FLAG_GETTING_ITINERARY_SUPPLIER_FOOD_REPORT,
  FLAG_ITINERARY_SUPPLIER_FOOD_ACTIVITY,
  FLAG_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE,
  FLAG_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT,
  FLAG_ITINERARY_SUPPLIER_FOODS,
  GET_ITINERARY_SUPPLIER_FOOD,
  GET_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE,
  GET_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT,
  GET_ITINERARY_SUPPLIER_FOOD_REPORT,
  GET_ITINERARY_SUPPLIER_FOOD_REPORT_DETAIL,
  GET_ITINERARY_SUPPLIER_FOODS,
} from '../types';
import { ITINERARY_SUPPLIER_FOOD_PATH } from '../../config/paths';
import { DATE_FORMAT } from '../../config/locale';
import { tzNormalizeDate } from '../../utils/date';

const flagGettingItinerarySupplierFoods = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_ITINERARY_SUPPLIER_FOODS,
    payload: flag,
  });

const getItinerarySupplierFoods = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingItinerarySupplierFoods(true));
    const query = tableFilters;
    const url = `${ITINERARY_SUPPLIER_FOOD_ENDPOINT}?${QueryString.stringify(
      query,
    )}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const suppliers = await response.json();
    dispatch({
      type: GET_ITINERARY_SUPPLIER_FOODS,
      payload: suppliers,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingItinerarySupplierFoods(false));
  }
};

const clearItinerarySupplierFoods = () => (dispatch) =>
  dispatch({
    type: CLEAR_ITINERARY_SUPPLIER_FOODS,
  });

const flagGettingItinerarySupplierFoodAssignmentService =
  (flag) => (dispatch) =>
    dispatch({
      type: FLAG_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE,
      payload: flag,
    });

const getItinerarySupplierFoodAssignmentService =
  ({ supplierId, departureDate }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingItinerarySupplierFoodAssignmentService(true));

      const query = {
        supplierId,
        departureDate,
      };

      const url = `${ITINERARY_SUPPLIER_FOOD_ENDPOINT}/assigned-service?${QueryString.stringify(
        query,
      )}`;

      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);

      const foods = await response.json();

      dispatch({
        type: GET_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE,
        payload: foods,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingItinerarySupplierFoodAssignmentService(false));
    }
  };

const clearItinerarySupplierFoodService = () => (dispatch) =>
  dispatch({
    type: CLEAR_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE,
  });

const flagGettingItinerarySupplierFoodAssignmentServiceDetail =
  (flag) => (dispatch) =>
    dispatch({
      type: FLAG_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT,
      payload: flag,
    });

const getItinerarySupplierFoodAssignmentServiceDetail =
  ({ itineraryId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingItinerarySupplierFoodAssignmentServiceDetail(true));

      const url = `${ITINERARY_SUPPLIER_FOOD_ENDPOINT}/assigned-service/detail/${itineraryId}`;

      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);

      const foods = await response.json();

      dispatch({
        type: GET_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT,
        payload: foods,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingItinerarySupplierFoodAssignmentServiceDetail(false));
    }
  };

const clearItinerarySupplierFoodServiceDetail = () => (dispatch) =>
  dispatch({
    type: CLEAR_ITINERARY_SUPPLIER_FOOD_ASSIGNMENT_SERVICE_CONTENT,
  });

const flagItinerarySupplierFoodActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_ITINERARY_SUPPLIER_FOOD_ACTIVITY,
    payload: flag,
  });

const postItinerarySupplierFood =
  ({
    supplierId,
    itineraryId,
    cabinCrewId,
    registeredBusId,
    itinerarySupplierFoodDetailList,
    itinerarySupplierFoodPassengerFlowList,
    scheduleDeliveredDate,
    comment,
  }) =>
  async (dispatch) => {
    try {
      dispatch(flagItinerarySupplierFoodActivity(true));

      const payload = {
        supplierId,
        itineraryId,
        cabinCrewId,
        registeredBusId,
        itinerarySupplierFoodDetailList,
        itinerarySupplierFoodPassengerFlowList,
        scheduleDeliveredDate,
        comment,
      };

      const url = ITINERARY_SUPPLIER_FOOD_ENDPOINT;

      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      const itinerarySupplierFood = await response.json();

      return itinerarySupplierFood;
    } catch ({ message }) {
      toastr.error('Error', message);
      return null;
    } finally {
      dispatch(flagItinerarySupplierFoodActivity(false));
    }
  };

const getItinerarySupplierFood =
  async ({ itinerarySupplierFoodId }) =>
  async (dispatch) => {
    try {
      dispatch(flagItinerarySupplierFoodActivity(true));
      const url = `${ITINERARY_SUPPLIER_FOOD_ENDPOINT}/${itinerarySupplierFoodId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const itinerarySupplierFood = await response.json();
      dispatch({
        type: GET_ITINERARY_SUPPLIER_FOOD,
        payload: itinerarySupplierFood,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagItinerarySupplierFoodActivity(false));
    }
  };

const clearItinerarySupplierFood = () => (dispatch) =>
  dispatch({
    type: CLEAR_ITINERARY_SUPPLIER_FOOD,
  });

const flagGettingItinerarySupplierFoodReport = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_ITINERARY_SUPPLIER_FOOD_REPORT,
    payload: flag,
  });

const getItinerarySupplierFoodReport =
  async ({ from, to, supplierId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingItinerarySupplierFoodReport(true));

      const query = {
        from,
        to,
        supplierId,
        size: 1000,
      };

      const url = `${ITINERARY_SUPPLIER_FOOD_ENDPOINT}/report?${QueryString.stringify(
        query,
      )}`;

      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

      await isErrorResponse(response, null, dispatch);

      const report = await response.json();

      dispatch({
        type: GET_ITINERARY_SUPPLIER_FOOD_REPORT,
        payload: report,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingItinerarySupplierFoodReport(false));
    }
  };

const getItinerarySupplierFoodReportExcel =
  async ({ from, to, supplierId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingItinerarySupplierFoodReport(true));

      const query = {
        from,
        to,
        supplierId,
        download: true,
      };

      const url = `${ITINERARY_SUPPLIER_FOOD_ENDPOINT}/report?${QueryString.stringify(
        query,
      )}`;

      const response = await fetch(url, EXCEL_GET_CONFIG);

      await isErrorResponse(response, null, dispatch);

      const blob = await response.blob();

      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = downloadUrl;

      const contentDisposition = response.headers.get('Content-Disposition');

      let fileName = `reporte-alimentacion-itinerarios-${tzNormalizeDate({
        format: DATE_FORMAT,
      })}.xlsx`;

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match) {
          [, fileName] = match;
        }
      }

      link.setAttribute('download', fileName);

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);

      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingItinerarySupplierFoodReport(false));
    }
  };

const getItinerarySupplierFoodReportInvoice =
  async ({ from, to, supplierId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingItinerarySupplierFoodReport(true));
      const query = {
        from,
        to,
        supplierId,
        size: 1000,
      };
      const url = `${ITINERARY_SUPPLIER_FOOD_ENDPOINT}/invoice?${QueryString.stringify(
        query,
      )}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const report = await response.json();
      dispatch({
        type: GET_ITINERARY_SUPPLIER_FOOD_REPORT,
        payload: report,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingItinerarySupplierFoodReport(false));
    }
  };

const clearItinerarySupplierFoodReport = () => (dispatch) =>
  dispatch({
    type: CLEAR_ITINERARY_SUPPLIER_FOOD_REPORT,
  });

const getItinerarySupplierFoodReportDetail =
  async ({ itinerarySupplierFoodId }) =>
  async (dispatch) => {
    try {
      dispatch(flagItinerarySupplierFoodActivity(true));
      const url = `${ITINERARY_SUPPLIER_FOOD_ENDPOINT}/report/detail/${itinerarySupplierFoodId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const reportDetail = await response.json();
      dispatch({
        type: GET_ITINERARY_SUPPLIER_FOOD_REPORT_DETAIL,
        payload: reportDetail,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagItinerarySupplierFoodActivity(false));
    }
  };

const clearItinerarySupplierFoodReportDetail = () => (dispatch) =>
  dispatch({
    type: CLEAR_ITINERARY_SUPPLIER_FOOD_REPORT_DETAIL,
  });

const deleteItineraryFoodSupplier =
  async (itinerarySupplierFoodId) => async (dispatch) => {
    try {
      dispatch(flagItinerarySupplierFoodActivity(true));

      const url = `${ITINERARY_SUPPLIER_FOOD_ENDPOINT}/${itinerarySupplierFoodId}`;

      const response = await fetch(url, {
        ...DEFAULT_GET_CONFIG,
        method: 'DELETE',
      });

      await isErrorResponse(response, null, dispatch);

      dispatch(push(ITINERARY_SUPPLIER_FOOD_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagItinerarySupplierFoodActivity(false));
    }
  };

const putItinerarySupplierFoodQuantityCost = (items) => async (dispatch) => {
  try {
    dispatch(flagItinerarySupplierFoodActivity(true));

    const url = `${ITINERARY_SUPPLIER_FOOD_ENDPOINT}/detail/quantity-cost`;

    const response = await fetch(url, {
      ...DEFAULT_POST_CONFIG,
      method: 'PUT',
      body: JSON.stringify(items),
    });

    await isErrorResponse(response, null, dispatch);

    const itinerarySupplierFoodDetails = await response.json();

    return itinerarySupplierFoodDetails;
  } catch ({ message }) {
    toastr.error('Error', message);
    return null;
  } finally {
    dispatch(flagItinerarySupplierFoodActivity(false));
  }
};

export {
  getItinerarySupplierFoods,
  clearItinerarySupplierFoods,
  flagGettingItinerarySupplierFoodAssignmentService,
  getItinerarySupplierFoodAssignmentService,
  clearItinerarySupplierFoodService,
  getItinerarySupplierFoodAssignmentServiceDetail,
  clearItinerarySupplierFoodServiceDetail,
  postItinerarySupplierFood,
  getItinerarySupplierFood,
  clearItinerarySupplierFood,
  getItinerarySupplierFoodReport,
  clearItinerarySupplierFoodReport,
  getItinerarySupplierFoodReportDetail,
  clearItinerarySupplierFoodReportDetail,
  getItinerarySupplierFoodReportInvoice,
  deleteItineraryFoodSupplier,
  getItinerarySupplierFoodReportExcel,
  putItinerarySupplierFoodQuantityCost,
};
